import customAxios from "config";
import { renterError } from "utils/errorMessage";

export const getInvoice = async (
  payload: any
): Promise<{ data?: any; error?: string }> => {
  try {
    const response = await customAxios.post<any>(
      "/api/bookings/tentative_booking_invoice/",
      payload
    );
    return response.data;
  } catch (error) {
    return { error: renterError(error, "invoice") };
  }
};
